export const TESTANIA_DEFAULT = process.env.TESTANIA_DEFAULT || '1.0.1';
export const HOTJAR_VERSION = 6;
